import produce from 'immer';
import create from 'zustand';
import { identity, pickBy } from 'lodash';

// Create request parameters based on search data
const createParameters = (search) => pickBy({
	related: 'students',
	state: search.state,
	'student.status': search.status,
	'student.name|student.surname:likeLower': `%${search.name}%`,
	orderBy: 'student.surname',
	page: search.page
}, identity);

// Initial search data
const SEARCH_INITIAL = {
	name: '',
	status: 'active',
	state: 'active',
	page: 1
};

// Initial store value
const GRADE_STUDENT_INITIAL = {
	// Search data
	search: SEARCH_INITIAL,

	// Request parameters
	parameters: createParameters(SEARCH_INITIAL),

	// Request options
	// Not implemented
	options: {
		all: false,
		selected: [],
		deselected: []
	},

	// Request data
	data: {
		all: false,
		subjectId: 0,
		courseId: 0,
		gradeId: 0,
		blankId: 0,
		startDate: null,
		endDate: null,
		additional: false,
		selected: [],
		deselected: []
	},

	// Collected data
	result: {
		students: [],
		total: 0
	}
};

export const useGradeStudentStore = create(set => ({
	...GRADE_STUDENT_INITIAL,

	// Handle search data change
	onSearch: ({ name, value }) => set(produce(state => {
		state.search[name] = value;
		if (name !== 'page') state.search.page = 1;
		state.parameters = createParameters(state.search);
	})),

	// Handle data change
	onChange: ({ name, value }) => set(produce(state => {
		state.data[name] = value;
	})),

	// Handle student selection or deselection based on all value
	onSelect: ({ name, value }) => set(produce(state => {
		if (state.options.all && value) {
			state.options.deselected = state.options.deselected.filter(id => id !== Number(name));
		} else if (state.options.all & !value) {
			state.options.deselected.push(Number(name));
		} else if (value) {
			state.options.selected.push(Number(name));
		} else {
			state.options.selected = state.options.selected.filter(id => id !== Number(name));
		}
	})),

	// Handle all student deselection
	onDeselectAll: () => set(produce(state => {
		state.options.all = false;
		state.options.selected = [];
		state.options.deselected = [];
	})),

	// Handle all student selection toggle in page
	onTogglePage: () => set(produce(state => {
		const selectedInPage = state.options.selected.filter(id => state.result.students.find(student => student.studentId === id));
		state.options.all = false;
		state.options.deselected = [];
		state.options.selected = selectedInPage.length
			? state.options.selected.filter(id => !selectedInPage.includes(id))
			: [...state.options.selected, ...state.result.students.map(student => student.studentId)];
	})),

	// Handle all student selection toggle
	onToggleAll: () => set(produce(state => {
		state.options.selected = [];
		state.options.deselected = [];
		state.options.all = !state.options.all;
	})),

	// Initialize collected data
	onInit: (result) => set(produce(state => {
		state.result.total = result.total ?? 0;
		state.result.students = result.students ?? [];
	})),

	// Reset store to initial state
	onReset: () => set({
		...GRADE_STUDENT_INITIAL
	})
}));